const PersonNameConverter= {

  shortName(fullName) {
    const convertFullName = fullName.split(" ");
    const surname = convertFullName[0];

    let name = "";
    if (convertFullName.length > 1) {
      name = convertFullName[1].charAt(0) + ".";
    }

    let patronymic = "";
    if (convertFullName.length > 2) {
      const firstLetterPatronymic = convertFullName[2].charAt(0) + ".";
      patronymic = " " + firstLetterPatronymic;
    }

    return surname + " " + name + patronymic;
  },

  joinToFullName(person) {
    try {
      let fullname = person.surname + " " + person.name[0] + "."
      if (person?.patronymic !== null && person?.patronymic !== "") fullname += person.patronymic[0] + "."
      return fullname
    } catch (e) {
      console.log(e);
      console.log(person)
    }
  },

}

export default PersonNameConverter